import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const VERZUZ_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_timbodaking-media/artifacts/59dey51b_image.png";
const VERZUZ_VIDEO = "https://www.youtube.com/embed/qtcJHzHC5mg";

const battles = [
  { m: "Swizz Beatz vs. Timbaland", d: "Mar 24, 2020 · The inaugural battle" },
  { m: "Teddy Riley vs. Babyface", d: "Apr 2020" },
  { m: "Erykah Badu vs. Jill Scott", d: "May 2020" },
  { m: "Lil Jon vs. T-Pain", d: "May 2020" },
  { m: "Nelly vs. Ludacris", d: "2020" },
  { m: "112 vs. Jagged Edge", d: "May 25, 2020" },
  { m: "Beenie Man vs. Bounty Killer", d: "May 2020" },
  { m: "Swizz Beatz vs. Timbaland", d: "May 2021 · The Verzuz rematch" },
  { m: "Omarion vs. Mario", d: "2022 · The pre-hiatus finale" },
  { m: "Cash Money vs. No Limit", d: "Oct 25, 2025 · Verzuz returns at ComplexCon" },
  { m: "Hit-Boy vs. Mike WiLL Made-It", d: "Jan 30, 2026 · Return of the Producers" },
  { m: "Tank vs. Tyrese", d: "Mar 2026" },
  { m: "Rick Ross vs. French Montana", d: "May 2026" },
  { m: "B2K vs. Pretty Ricky", d: "Jun 2026" },
  { m: "YG vs. The Game", d: "Jul 2026" },
];

export default function VerzuzFeature() {
  return (
    <section className="relative bg-[#0d0d0d] py-24 md:py-36 border-t border-white/10" data-testid="verzuz-feature">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 80% 20%, rgba(79, 176, 74,0.12), transparent 55%)" }} />
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5 text-center md:text-left">
            <Reveal>
              <img src={VERZUZ_LOGO} alt="Verzuz" className="w-40 md:w-56 h-auto object-contain mb-8 mx-auto md:mx-0" data-testid="verzuz-logo" />
              <p className="overline text-gold mb-4">Co-Created By Timbaland</p>
              <h2 className="headline text-5xl md:text-7xl text-white leading-[0.9]">The Battles</h2>
            </Reveal>
          </div>

          <div className="md:col-span-7">
            <Reveal delay={0.1}>
              <p className="font-body text-white/70 text-lg md:text-xl leading-relaxed mb-4">
                In March 2020, with the world locked down, Timbaland and Swizz Beatz turned Instagram Live into event
                television. Verzuz put catalog against catalog, hit against hit, and gave a generation of producers and
                artists their flowers in real time.
              </p>
              <p className="font-body text-white/50 text-base leading-relaxed mb-10">
                It started with the two founders squaring off themselves on March 24, 2020, then grew into a cultural
                movement that reframed how we celebrate Black music history.
              </p>

              <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
                {battles.map((b, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-30px" }}
                    transition={{ duration: 0.5, delay: (i % 2) * 0.06 }}
                    className="bg-[#0d0d0d] p-5 hover:bg-white/[0.03] transition-colors"
                    data-testid={`verzuz-battle-${i}`}
                  >
                    <p className="font-display uppercase tracking-[0.08em] text-sm text-white/90">{b.m}</p>
                    <p className="font-body text-[0.72rem] text-gold/80 mt-1">{b.d}</p>
                  </motion.div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        {/* Full replay */}
        <Reveal delay={0.1} className="mt-16 md:mt-24">
          <p className="overline text-gold mb-6">Watch · Swizz Beatz vs. Timbaland, The Rematch</p>
          <div className="relative w-full aspect-video border border-white/10 overflow-hidden" data-testid="verzuz-video">
            <iframe
              title="Swizz Beatz vs Timbaland Verzuz"
              src={VERZUZ_VIDEO}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
